export default "__VITE_ASSET__BYkYJdo8__"